var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRoundedPrimaryDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 16,
    height: 16,
    rx: 8,
    transform: "rotate(-180 16 16)",
    fill: "#DBD6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16806 6.74228C4.47441 6.28275 5.09528 6.15858 5.55481 6.46493L8.00011 8.09513L10.4454 6.46493C10.9049 6.15858 11.5258 6.28275 11.8322 6.74228C12.1385 7.20181 12.0143 7.82268 11.5548 8.12903L8.00011 10.4988L4.44541 8.12903C3.98588 7.82268 3.8617 7.20181 4.16806 6.74228Z",
    fill: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRoundedPrimaryDown);
export default __webpack_public_path__ + "static/media/chevron-rounded-primary-down.d6468fa1d9bf8a1604b34e4d9ae35b7b.svg";
export { ForwardRef as ReactComponent };